(() => {
  const source = document.currentScript;
  const name = source?.dataset.productTitle;
  const path = source?.dataset.productPath;
  if (!name || !path) return;
  const selector = 'script.jdgm-aggregate-rating-jld';
  const sync = (script) => {
    try {
      const data = JSON.parse(script.textContent);
      if (data['@type'] !== 'Product' || !data['@id']) return;
      if (new URL(data['@id'], location.origin).pathname !== path) return;
      if (data.name === name && data['@id'] === path + '#product') return;
      data.name = name;
      data['@id'] = path + '#product';
      script.textContent = JSON.stringify(data);
    } catch { /* Leave unrelated or incomplete app data untouched. */ }
  };
  document.querySelectorAll(selector).forEach(sync);
  new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType !== Node.ELEMENT_NODE) continue;
        if (node.matches(selector)) sync(node);
        node.querySelectorAll(selector).forEach(sync);
      }
    }
  }).observe(document.body, {childList: true});
})();
